import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/transactions';

export async function uploadTransactionsFile(file, token) {
  const formData = new FormData();
  formData.append('file', file);
  
  try {
    const response = await axios.post(`${API_BASE_URL}/upload`, formData, {
      headers: {
        Authorization: "Bearer " + token,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al subir archivo: ' + (error.response?.data?.message || error.message));
  }
}

export async function getTransactions(token, filters = {}) {
  try {
    const response = await axios.get(API_BASE_URL, {
      params: filters,
      headers: {
        Authorization: "Bearer " + token
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteTransaction(id, token) {
  try {
    const response = await axios.delete(`${API_BASE_URL}/${id}`, {
      headers: {
        Authorization: "Bearer " + token
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al eliminar transacción: ' + (error.response?.data?.message || error.message));
  }
}

export async function deleteTransactionBatch(batchId, token) {
  try {
    const response = await axios.delete(`${API_BASE_URL}/batch/${batchId}`, {
      headers: {
        Authorization: "Bearer " + token
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al eliminar el lote de transacciones: ' + (error.response?.data?.message || error.message));
  }
}

export async function getUploadHistory(token) {
  try {
    const response = await axios.get(`${API_BASE_URL}/history`, {
      headers: {
        Authorization: "Bearer " + token
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener el historial de cargas: ' + (error.response?.data?.message || error.message));
  }
}

export async function getAccountStatement(token, filters = {}) {
  try {
    const response = await axios.get(`${API_BASE_URL}/estado-cuenta`, {
      params: filters,
      headers: {
        Authorization: "Bearer " + token
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener el estado de cuenta: ' + (error.response?.data?.message || error.message));
  }
}

export async function getResumenHistorico(token, mode, targetId) {
  try {
    const response = await axios.get(`${API_BASE_URL}/estado-cuenta`, {
      params: { mode, targetId, summaryOnly: true },
      headers: {
        Authorization: "Bearer " + token
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener el resumen histórico: ' + (error.response?.data?.message || error.message));
  }
}


export async function generateAccountStatementPDF(token, data) {
  try {
    const response = await axios.post(`${API_BASE_URL}/generar-estado-cuenta`, data, {
      headers: {
        Authorization: "Bearer " + token,
        'Content-Type': 'application/json'
      },
      responseType: 'arraybuffer', // Importante para recibir el archivo binario sin corromperse
    });

    // Crear un blob y forzar la descarga en el navegador
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    // Intentar extraer el nombre del archivo del header Content-Disposition si existe
    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'estado_cuenta.pdf';
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
      if (fileNameMatch && fileNameMatch.length === 2) {
        fileName = fileNameMatch[1];
      }
    }
    
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    
    // Limpieza
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    throw new Error('Error al generar o descargar el PDF: ' + (error.response?.data?.message || error.message));
  }
}

